<template lang="pug">
  v-list(color="transparent")
    template(
      v-if="items.length"
    )
      v-subheader.mb-3
        div(v-if="!multiple")
          .title Выберите курс
        div(v-if="multiple")
          .title.mb-1
            span Курсы
            v-chip(
              small
            ).ml-3
              span Выбрано -
              strong.ml-1
                template(v-if="!value.length") для всех
                template(v-else) {{ value.length }}
              v-icon(
                v-if="value.length"
                right
                small
                @click="$emit('input', [])"
              ) mdi-close-circle

          .caption Выберите один или несколько
      template(v-if="loading")
        v-list-item
          v-progress-linear(
            rounded
            indeterminate
          )
      v-list-item-group(
        :value="value"
        :multiple="multiple"
        @change="$emit('input', $event)"
      )
        v-list-item(
          v-for="course in items"
          :key="course.id"
          :value="course"
        ).my-2
          v-list-item-avatar
            v-img(
              :src="course.image_file_url || require('@/assets/course-sample.png')"
            )
          v-list-item-content
            v-list-item-title {{ course.title }}
    template(v-else)
      v-alert(type="info" outlined) Нет активных курсов
</template>

<script>
export default {
  props: {
    value: { type: [Array, Object], default: () => ([]) },
    items: { type: Array, default: () => ([]) },
    multiple: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
};
</script>
